import React from 'react'
import PropTypes from 'prop-types'

import Flag from 'src/components/Flag/Flag'
import { t } from 'src/lib/i18n-react'
import { Flex, Image } from '@chatterbug/aaron'

import confirmed from './assets/confirmed.svg'
import pending from './assets/pending.svg'

const STATUS_IMAGES = {
  PENDING: pending,
  CONFIRMED: confirmed,
  TUTOR_PENDING: pending,
}

const AppointmentStatus = ({ status, language }) => {
  return (
    <Flex alignItems="center">
      <Flex as="span" marginRight="-10px">
        <Flag
          countryCode={language.code}
          size="middle"
          borderColor="dark"
          alt={t('%{language} lesson', { language: language.localizedName })}
        />
      </Flex>
      <Image
        src={STATUS_IMAGES[status]}
        // TODO: localized status infomration
        alt={status}
      />
    </Flex>
  )
}

AppointmentStatus.propTypes = {
  language: PropTypes.object,
  status: PropTypes.string,
}

export default AppointmentStatus
